import _ from 'lodash'
import React, { useEffect } from 'react'
import ReactCSSTransitionGroup from 'react-addons-css-transition-group'
import ReactTable from 'react-table'
import Moment from 'moment'
import {
  UncontrolledTooltip,
  Card,
  Button,
  Col,
  Container,
  Row,
  Input,
  FormGroup,
  Modal, ModalHeader
} from 'reactstrap'

import LoadingOverlay from 'components/Indicator/LoadingOverlay'
import SearchForm from './SearchForm'
import DeleteConfirmationModal from 'components/Modal/deleteConfirmation'
import PageTitle from 'components/Title/PageTitle'
import CustomPagination from 'components/Pagination'
import PassForm from './Form'
import { toast } from 'react-toastify'

import PortalUsersHOC from './action'

import Lang from 'Lang/General'

const PortalUsers = props => {

  useEffect(() => {
    props.getCompanies()
    props.getFairs()
    let tmpIndex = _.findIndex(props.data.selectCenterReducer.selectedCenter.center.modules, { name: 'Fair' })
    props.onChangePassesHOC('subscribedPackage', tmpIndex > -1)
    props.getPasses({
      page: 1,
      is_paginated: true,
      filter: {
        "client_id": props.data.selectCenterReducer.selectedCenter.center.client_id,
        "show_mode": "all"
      }
    })
  }, [])

  useEffect(() => {
    let temp = _.cloneDeep(props.searchParams)
    temp[0]['options'] = props.companies
    temp[1]['options'] = props.fairs

    props.onChangePassesHOC('searchParams', temp)
  }, [props.companies, props.fairs])

  const onHandleCheck = id => {
    let tempDownload = _.cloneDeep(props.selectedtoDownload)
    let tempIndex = _.findIndex(props.selectedtoDownload, val => val === id)
    if (tempIndex < 0) {
      tempDownload.push(id)
    } else {
      tempDownload.splice(tempIndex, 1)
    }

    props.onChangePassesHOC('selectedtoDownload', tempDownload)
  }

  const onHandleCheckAll = () => {
    if (props.selectedtoDownload.length === props.passes.length) {
      return props.onChangePassesHOC('selectedtoDownload', [])
    }

    let tempIDs = _.map(props.passes, passChild => passChild.id)
    return props.onChangePassesHOC('selectedtoDownload', tempIDs)
  }

  const permissionHandle = (context) => {
    let tmp = _.find(props.data.roleReducer.role.platforms, { name: 'Aciso Cockpit' })
    let tmpModules = {}
    if (tmp) {
      tmpModules = _.find(tmp.modules, { name: 'Fair' })
      return props.subscribedPackage && tmpModules[context]
    }
  }

  return (
    <>
      <PageTitle
        heading={Lang['FAIR_PASSES'][props.data.languageReducer.userSettings.admin_panel_language]}
        icon="pe-7s-ticket icon-gradient bg-happy-itmeo"
        buttons={[]}
      />
      <ReactCSSTransitionGroup
        component="div"
        transitionName="TabsAnimation"
        transitionAppear={true}
        transitionAppearTimeout={0}
        transitionEnter={false}
        transitionLeave={false}>
        <Container fluid>
          <Row>
            <Col md={12}>
              <SearchForm
                searchParams={props.searchParams}
                onChangeHOCState={props.onChangePassesHOC}
                getListAPI={(query, context) => {
                  if ((!query.filter.fair_short_titles || _.isEmpty(query.filter.fair_short_titles)) && context === 'search') {
                    return toast.error(
                      Lang['PLEASE_SELECT_FAIR'][props.data.languageReducer.userSettings.admin_panel_language]
                    )
                  }

                  props.getPasses(query)
                }}
                defaultSearchParams={[
                  {
                    label: Lang['COMPANY'][props.data.languageReducer.userSettings.admin_panel_language],
                    col: 6,
                    value: 'company_names',
                    param: '',
                    type: 'multi-select',
                    isMulti: true,
                    options: props.companies
                  },
                  {
                    label: Lang['FAIR_SHORT'][props.data.languageReducer.userSettings.admin_panel_language],
                    value: 'fair_short_titles',
                    col: 6,
                    param: '',
                    type: 'multi-select',
                    options: props.fairs
                  },
                  {
                    label: '',
                    value: 'show_mode',
                    col: 12,
                    param: 'all',
                    type: 'radio',
                    options: [
                      {
                        id: 'all',
                        name: 'Show all'
                      },
                      {
                        id: 'already_downloaded',
                        name: 'Show already download'
                      },
                      {
                        id: 'not_downloaded',
                        name: 'Show not download'
                      }
                    ]
                  },
                ]}
                defaultQuery={{
                  page: 1,
                  is_paginated: true,
                  filter: {
                    "client_id": props.data.selectCenterReducer.selectedCenter.center.client_id,
                    "show_mode": "all"
                  }
                }}
              />
            </Col>
            <Col md={12}>
              <Card className='main-card mb-3 p-4' >
                <div className="d-flex mb-3">
                  {
                    props.searchParams[1].param && props.passes?.[0] && (
                      <Button
                        color={'primary'} className={'ml-auto'}
                        onClick={() => props.downloadAllPasses(props.passes[0].fair_short)}
                      >
                        {Lang['DOWNLOAD_ALL'][props.data.languageReducer.userSettings.admin_panel_language]}
                      </Button>
                    )
                  }
                  {
                    props.selectedtoDownload.length > 0 && (
                      <Button
                        color={'primary'} className={`${!(props.searchParams[1].param && props.passes?.[0]) ? 'ml-auto' : 'ml-2'}`}
                        onClick={() => {
                          props.downloadPasses({
                            pass_ids: props.selectedtoDownload,
                            fair_short: props.passes[0].fair_short
                          }, props.passes[0].fair_short)
                        }}
                      >
                        {Lang['DOWNLOAD_SELECTED'][props.data.languageReducer.userSettings.admin_panel_language]}
                      </Button>
                    )
                  }
                </div>
                <ReactTable
                  defaultPageSize={10}
                  showPagination={false}
                  NoDataComponent={() => <span></span>}
                  data={props.passes}
                  columns={[
                    {
                      Header: <>
                        <Input
                          type={'checkbox'}
                          checked={props.selectedtoDownload.length > 0 && props.selectedtoDownload.length === props.passes.length}
                          onChange={() => onHandleCheckAll()}
                        />
                        <span className='ml-1'>{Lang['SELECT_ALL'][props.data.languageReducer.userSettings.admin_panel_language]}</span>
                      </>,
                      Cell: (row, index) => (
                        <FormGroup
                          check
                          className={'d-flex justify-content-center w-100 align-items-center'}
                        >
                          <Input
                            type={'checkbox'}
                            checked={props.selectedtoDownload.indexOf(row.original.id) > -1}
                            onChange={() => onHandleCheck(row.original.id)}
                          />
                        </FormGroup>
                      )
                    },
                    {
                      Header: Lang['COMPANY'][props.data.languageReducer.userSettings.admin_panel_language],
                      accessor: 'company'
                    },
                    {
                      Header: Lang['FAIR_SHORT'][props.data.languageReducer.userSettings.admin_panel_language],
                      accessor: 'fair_short'
                    },
                    {
                      Header: Lang['FIRST_NAME'][props.data.languageReducer.userSettings.admin_panel_language],
                      accessor: 'first_name'
                    },
                    {
                      Header: Lang['LAST_NAME'][props.data.languageReducer.userSettings.admin_panel_language],
                      accessor: 'last_name'
                    },
                    {
                      Header: Lang['DOWNLOADED'][props.data.languageReducer.userSettings.admin_panel_language],
                      accessor: 'downloaded',
                      Cell: row => (
                        row.original.downloaded_date
                          ? Moment(row.original.downloaded_date).format('DD-MM-YYYY')
                          : '-'
                      )
                    },
                    {
                      Header: Lang['ACTIONS'][props.data.languageReducer.userSettings.admin_panel_language],
                      Cell: (row) => {
                        return (
                          <div style={{ display: "block" }}>
                            {
                              permissionHandle('is_delete') && (
                                <>
                                  <Button
                                    id={`Forms-${row.original.id}-edit`}
                                    className="mr-2 mb-2 btn-icon btn-icon-only"
                                    color="primary"
                                    onClick={() => {
                                      props.onChangePassesHOC('selectedToEdit', row.original)
                                      props.onChangePassesHOC('showEditModal', true)
                                    }}
                                  >
                                    <i className="pe-7s-pen btn-icon-wrapper"> </i>
                                  </Button>
                                  <UncontrolledTooltip
                                    target={`Forms-${row.original.id}-edit`}
                                    placement="top">
                                    {Lang['UPDATE_PASSES'][props.data.languageReducer.userSettings.admin_panel_language]}
                                  </UncontrolledTooltip>
                                  <Button
                                    id={`Forms-${row.original.id}-delete`}
                                    className='mb-2 mr-2 btn-icon btn-icon-only'
                                    color='danger'
                                    onClick={() => {
                                      Promise.all([
                                        props.onChangePassesHOC('selectedToDelete', row.original)
                                      ]).then(
                                        props.onChangePassesHOC('showDeleteModal', true)
                                      )
                                    }}>
                                    <i className='pe-7s-trash'> </i>
                                  </Button>
                                  <UncontrolledTooltip
                                    target={`Forms-${row.original.id}-delete`}
                                    placement='top'>
                                    {Lang['DELETE'][props.data.languageReducer.userSettings.admin_panel_language]}
                                  </UncontrolledTooltip>
                                </>
                              )
                            }
                          </div>
                        )
                      }
                    }
                  ]}
                />
                <CustomPagination
                  meta={props.passesMeta || {}}
                  onChangePage={val => {
                    props.getPasses({
                      ...props.query,
                      page: val,
                    })
                  }}
                />
              </Card>
            </Col>
          </Row>
        </Container>
      </ReactCSSTransitionGroup>
      {
        (props.showDeleteModal &&
          !_.isEmpty(props.selectedToDelete)) && (
          <DeleteConfirmationModal
            handleModalClose={() => props.onChangePassesHOC('showDeleteModal', false)}
            confirmAction={() => {
              props.deletePasses(props.selectedToDelete.id)
            }}
            content={Lang['ARE_YOU_SURE_TO_DELETE_PASSES'][props.data.languageReducer.userSettings.admin_panel_language]}
            lang={props.data.languageReducer.userSettings.admin_panel_language}
          />
        )
      }
      <Modal
        isOpen={props.showEditModal && !_.isEmpty(props.selectedToEdit)}
        toggle={() => {
          props.onChangePassesHOC('showEditModal', false)
          props.onChangePassesHOC('selectedToEdit', null)
        }}
      >
        <ModalHeader toggle={() => {
          props.onChangePassesHOC('showEditModal', false)
          props.onChangePassesHOC('selectedToEdit', null)
        }}>
          {Lang['UPDATE_PASSES'][props.data.languageReducer.userSettings.admin_panel_language]}
        </ModalHeader>
        <PassForm
          {...props}
          onSubmit={val => props.updatePasses(val)}
        />
      </Modal>
      {props.onLoadPasses && <LoadingOverlay />}
    </>
  )
}

export default PortalUsersHOC(PortalUsers)
